<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import ServiceRecordForm from "../../../components/settings/servicerecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ServiceRecordForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setupservicerectype.newservicerectype'),
      formData: {
        movtypeid: null,
        movtypedid: null,
        movcode: null,
        movdesc: null,
        ishire: false,
        islocmov: false,
        isjobmov: false,
        issalmov: false,
        iscontrmov: false,
        isconfirmation: false,
        iscessation: false,
        remark: null,
        isdisable: false,
        movstamp: 0,
        movdstamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      // Convert boolean to integer. 1 = true, 0 = false
      if (this.formData.isdisable == false) {
        this.formData.isdisable = 0;
      } else {
        this.formData.isdisable = 1;
      }

      if (this.formData.ishire == false) {
        this.formData.ishire = 0;
      } else {
        this.formData.ishire = 1;
      }

      if (this.formData.islocmov == false) {
        this.formData.islocmov = 0;
      } else {
        this.formData.islocmov = 1;
      }

      if (this.formData.isjobmov == false) {
        this.formData.isjobmov = 0;
      } else {
        this.formData.isjobmov = 1;
      }

      if (this.formData.issalmov == false) {
        this.formData.issalmov = 0;
      } else {
        this.formData.issalmov = 1;
      }

      if (this.formData.iscontrmov == false) {
        this.formData.iscontrmov = 0;
      } else {
        this.formData.iscontrmov = 1;
      }

      if (this.formData.isconfirmation == false) {
        this.formData.isconfirmation = 0;
      } else {
        this.formData.isconfirmation = 1;
      }

      if (this.formData.iscessation == false) {
        this.formData.iscessation = 0;
      } else {
        this.formData.iscessation = 1;
      }

      this.$store.dispatch('post', {url: "/movtype/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "servicerecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "servicerecordlist" });
    },
  },
};
</script>